import { createSelector } from "reselect";

export const getData = state => state.app.user;

export const getUser = createSelector(getData, ({ user = {} }) => user);

export const getAdvancedConfiguration = createSelector(
  getData,
  ({ advancedConfiguration = {} }) => advancedConfiguration
);
